<div class="min-w-0 max-w-full h-full flex flex-col ">
<div class="w-full flex items-center justify-between mt-1  h-fit">
    <div class="flex items-center "> <img src="../../assets/svg/powerGeneration.svg" alt="preview"> <span
            class="font-normal  text-[#AEB9E1] sm:text-sm md:text-lg tracking-[2%] ml-1.5">{{"pr/cuf"
            |translate}}</span> </div>
     <div class="rounded-2xl p-3 bg-slate-600 text-white h-7 flex justify-center items-center w-fit mr-2.5 ">
                        7 Days</div>
</div>
<div class=" flex-1 min-h-0 min-w-0 overflow-hidden flex items-center ">
    @if (
    chartOptions &&
    chartOptions.chart?.type &&
    chartOptions.series &&
    chartOptions.series.length > 0
    ) {
    <div class="flex flex-grow justify-center items-center w-full">
         <apx-chart class="w-full  max-w-full text-black " 
         [series]="chartOptions.series!"
        [colors]="chartOptions.colors!"
        [chart]="chartOptions.chart!"
         [xaxis]="chartOptions.xaxis!" 
         [yaxis]="chartOptions.yaxis!"
        [tooltip]="chartOptions.tooltip!"
         [dataLabels]="chartOptions.dataLabels!" 
         [stroke]="chartOptions.stroke!"
        [plotOptions]="chartOptions.plotOptions!" 
        [grid]="chartOptions.grid!"
          [legend]="chartOptions.legend!"
          ></apx-chart>
    </div>
    } @else {

    <div class="flex flex-grow justify-center items-center h-full sm:mt-16 md:mt-20 lg:mt-24">
        <span class="text-xs dark:text-white">{{
            "no_record_found" | translate
            }}</span>
    </div>
    }


</div>